import { render } from "./stopwatch.vue?vue&type=template&id=5362f1b9&scoped=true&bindings={\"isFinishedShow\":\"props\",\"timerInterval\":\"data\",\"isStopwatchActive\":\"data\",\"countedTime\":\"data\",\"formattedTime\":\"options\",\"startTimer\":\"options\",\"incrementTimer\":\"options\",\"toggleStopwatch\":\"options\",\"stopStopwatch\":\"options\",\"startStopwatch\":\"options\",\"resetStopwatch\":\"options\",\"getFormattedTime\":\"options\"}"
import script from "./stopwatch.vue?vue&type=script&lang=js"
export * from "./stopwatch.vue?vue&type=script&lang=js"

import "./stopwatch.vue?vue&type=style&index=0&id=5362f1b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5362f1b9"

export default script